import * as types from 'constants/autenticacion.ActionTypes';

const initialState = {
  autenticacion: {
    loading: false,
    data: {},
    error: null
  },
  estados: {
    loading: false,
    data: [],
    error: null
  },
  indicadores: {
    loading: false,
    data: {},
    error: null
  },
  captcha: {
    loading: false,
    data: {},
    error: null
  },
  cerrarSesion: {
    loading: false,
    data: {},
    error: null
  },
  menuSistemas: {
    loading: false,
    data: [],
    error: null
  }
};

export default (state = { ...initialState }, action = {}) => {
  switch (action.type) {
    case types.GET_AUTENTICACION_LOADING: {
      return {
        ...state,
        autenticacion: {
          ...state.autenticacion,
          loading: true,
          error: null
        }
      };
    }
    case types.GET_AUTENTICACION_SUCCESS: {
      const { payload } = action;
      return {
        ...state,
        autenticacion: {
          ...state.autenticacion,
          loading: false,
          data: payload,
          error: null
        }
      };
    }
    case types.GET_AUTENTICACION_FAILURE: {
      const { error } = action;
      return {
        ...state,
        autenticacion: {
          ...state.autenticacion,
          loading: false,
          error
        }
      };
    }
    case types.GET_ESTADOS_LOADING: {
      return {
        ...state,
        estados: {
          ...state,
          loading: true,
          error: null
        }
      };
    }
    case types.GET_ESTADOS_SUCCESS: {
      const { payload } = action;
      return {
        ...state,
        estados: {
          ...state,
          loading: false,
          error: null,
          data: payload
        }
      };
    }
    case types.GET_ESTADOS_FAILURE: {
      const { error } = action;
      return {
        ...state,
        estados: {
          ...state,
          loading: false,
          error
        }
      };
    }
    case types.GET_INDICADORES_LOADING: {
      return {
        ...state,
        indicadores: {
          ...state.indicadores,
          loading: true,
          error: null
        }
      };
    }
    case types.GET_INDICADORES_SUCCESS: {
      const { payload } = action;
      return {
        ...state,
        indicadores: {
          ...state.indicadores,
          loading: false,
          data: payload,
          error: null
        }
      };
    }
    case types.GET_INDICADORES_FAILURE: {
      const { error } = action;
      return {
        ...state,
        indicadores: {
          ...state.indicadores,
          loading: false,
          error
        }
      };
    }
    case types.GET_CAPTCHA_LOADING: {
      return {
        ...state,
        captcha: {
          ...state.captcha,
          loading: true,
          error: null
        }
      };
    }
    case types.GET_CAPTCHA_SUCCESS: {
      const { payload } = action;
      return {
        ...state,
        captcha: {
          ...state.captcha,
          loading: false,
          data: payload,
          error: null
        }
      };
    }
    case types.GET_CAPTCHA_FAILURE: {
      const { error } = action;
      return {
        ...state,
        captcha: {
          ...state.captcha,
          loading: false,
          error
        }
      };
    }
    case types.GET_CERRAR_SESION_LOADING: {
      return {
        ...state,
        cerrarSesion: {
          ...state.cerrarSesion,
          loading: true,
          error: null
        }
      };
    }
    case types.GET_CERRAR_SESION_SUCCESS: {
      const { payload } = action;
      return {
        ...state,
        cerrarSesion: {
          ...state.cerrarSesion,
          loading: false,
          data: payload,
          error: null
        }
      };
    }
    case types.GET_CERRAR_SESION_FAILURE: {
      const { error } = action;
      return {
        ...state,
        cerrarSesion: {
          ...state.cerrarSesion,
          loading: false,
          error
        }
      };
    }
    case types.GET_MENU_SISTEMAS_LOADING: {
      return {
        ...state,
        menuSistemas: {
          ...state.menuSistemas,
          loading: true,
          error: null
        }
      };
    }
    case types.GET_MENU_SISTEMAS_SUCCESS: {
      const { payload } = action;
      return {
        ...state,
        menuSistemas: {
          ...state.menuSistemas,
          loading: false,
          data: payload,
          error: null
        }
      };
    }
    case types.GET_MENU_SISTEMAS_FAILURE: {
      const { error } = action;
      return {
        ...state,
        menuSistemas: {
          ...state.menuSistemas,
          loading: false,
          error
        }
      };
    }
    default:
      return state;
  }
};
